module.exports = __webpack_public_path__ + "img/anan_yes.6c3b4024.png";